'use client';

import { clientFetch } from '@/lib/api/clientFetch';
import { useEffect, useMemo, useState } from 'react';

export default function useUnreadInboxCount(enabled = false) {
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    if (!enabled) {
      setUnreadCount(0);
      return undefined;
    }

    let cancelled = false;

    clientFetch('/api/inbox/unread-count')
      .then((payload) => {
        if (cancelled) {
          return;
        }

        setUnreadCount(Math.max(0, Number(payload?.unread || 0) || 0));
      })
      .catch(() => {
        if (!cancelled) {
          setUnreadCount(0);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [enabled]);

  const unreadBadgeText = useMemo(
    () => (unreadCount > 99 ? '99+' : String(unreadCount)),
    [unreadCount],
  );

  return { unreadCount, unreadBadgeText };
}
